<template>
  <section class="member-enterprises-container">
    <div class="member-enterprises-container--inner">
      <div class="sec-title-container">
        <div class="sec-title-zh">合作客户</div>
        <div class="sec-title-en">PARTHER CUSTOMER</div>
      </div>
      <div class="member-enterprises-content">
        <template v-for="(item, index) in listData">
          <div class="member-item" :class="item.class" :key="index">
            <div class="member-item-container">
              <div class="member-item-image-container">
                <img :src="item.imgSrc" alt="" />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      listData: [
        {
          imgSrc: '/static/images/jjy.png',
        },
        {
          imgSrc: '/static/images/wb.png',
        },
        {
          imgSrc: '/static/images/szd.png',
        },
        {
          imgSrc: '/static/images/hxgw.png',
        },
        {
          imgSrc: '/static/images/bd.png',
        },
        {
          imgSrc: '/static/images/zyh.png',
        },
        {
          imgSrc: '/static/images/yfc.png',
          class: 'logo-yfc',
        },
        {
          imgSrc: '/static/images/mh.png',
        },
        {
          imgSrc: '/static/images/glc.png',
        },
        {
          imgSrc: '/static/images/jz.png',
          class: 'logo-jz',
        },
        {
          imgSrc: '/static/images/hxgc.png',
        },
        {
          imgSrc: '/static/images/fdl.png',
        },
        {
          imgSrc: '/static/images/rb.png',
        },
        {
          imgSrc: '/static/images/jgh.png',
        },
        {
          imgSrc: '/static/images/lj.png',
        },
        {
          imgSrc: '/static/images/sp.png',
        },
        {
          imgSrc: '/static/images/hb.png',
        },
        {
          imgSrc: '/static/images/xjc.png',
        },
        {
          imgSrc: '/static/images/rj.png',
        },
        {
          imgSrc: '/static/images/yzj.png',
        },
      ],
    }
  },
}
</script>
